export default __webpack_public_path__ + "static/media/association-header.9555b05b.svg";